function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  filter: "url(#filter0_d)"
}, /*#__PURE__*/React.createElement("rect", {
  x: 8,
  y: 8,
  width: 60,
  height: 60,
  rx: 30,
  fill: "#C94780",
  id: "front"
}), /*#__PURE__*/React.createElement("path", {
  d: "M38 43.0002C38.1483 43.0002 38.2933 43.0442 38.4167 43.1266C38.54 43.209 38.6361 43.3261 38.6929 43.4632C38.7496 43.6002 38.7645 43.751 38.7356 43.8965C38.7066 44.042 38.6352 44.1756 38.5303 44.2805C38.4254 44.3854 38.2918 44.4568 38.1463 44.4857C38.0008 44.5147 37.85 44.4998 37.713 44.4431C37.5759 44.3863 37.4588 44.2902 37.3764 44.1668C37.294 44.0435 37.25 43.8985 37.25 43.7502C37.25 43.5513 37.329 43.3605 37.4697 43.2198C37.6103 43.0792 37.8011 43.0002 38 43.0002Z",
  fill: "white",
  stroke: "white",
  strokeWidth: 1.71427,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M38 38.5003V32.5004",
  stroke: "white",
  strokeWidth: 1.71427,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M49.6268 43.8641C49.8976 44.4051 50.0255 45.0064 49.9985 45.6108C49.9714 46.2152 49.7902 46.8026 49.4722 47.3172C49.1541 47.8319 48.7098 48.2567 48.1813 48.5512C47.6528 48.8457 47.0578 49.0002 46.4528 49H29.5492C28.9442 49.0002 28.3492 48.8457 27.8207 48.5512C27.2922 48.2567 26.8479 47.8319 26.5298 47.3172C26.2118 46.8026 26.0306 46.2152 26.0036 45.6108C25.9765 45.0064 26.1044 44.4051 26.3752 43.8641L34.8271 26.9624C35.1216 26.3728 35.5746 25.8768 36.1352 25.5302C36.6958 25.1836 37.3419 25 38.001 25C38.6601 25 39.3062 25.1836 39.8668 25.5302C40.4274 25.8768 40.8804 26.3728 41.1749 26.9624L49.6268 43.8641Z",
  stroke: "white",
  strokeWidth: 1.71427,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}));

var _ref3 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
  id: "filter0_d",
  x: 0,
  y: 0,
  width: 76,
  height: 76,
  filterUnits: "userSpaceOnUse",
  colorInterpolationFilters: "sRGB"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  type: "matrix",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
}), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 4
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  type: "matrix",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.08 0"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in2: "BackgroundImageFix",
  result: "effect1_dropShadow"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in: "SourceGraphic",
  in2: "effect1_dropShadow",
  result: "shape"
})));

function SvgAnswerWrong(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 76,
    height: 76,
    viewBox: "0 0 76 76",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAnswerWrong);
export default __webpack_public_path__ + "static/media/answer-wrong.b6aca326.svg";
export { ForwardRef as ReactComponent };